<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <app-section-loader :status="loading.getList"></app-section-loader>
                    <v-card-title>
                        <v-layout row>
                            <v-flex auto class="pa-0">
                                <h4>BẢNG TÍNH TIỀN TRẢ CỌC</h4>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout row justify-end>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tìm theo"
                                    :disabled="loading.submit"
                                    v-model="search_type"
                                    :items="list_search_type"
                                    prepend-icon="visibility"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3 class="pb-0">
                                <v-btn @click="getTablesData" color="primary" dark class="mt-3 mb-0">
                                    Tìm kiếm
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card class="mt-4">
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                        <template #items="props">
                            <tr>
                                <td class="text-center">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ma-0"
                                                flat
                                                icon
                                                color="blue"
                                                v-on="on"
				                                @click="getReturnDepositDetail(props.item)"
                                                :loading="props.item.loading"
                                            >
                                                <v-icon class="zmdi zmdi-assignment"></v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Xem chi tiết hóa đơn tiền phòng</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-center">{{ props.item.room_id }}</td>
                                <td class="text-center">
                                    <span :class="['v-badge', props.item.status ? 'primary' : '']">
                                        {{ props.item.status ? "Đã chi trả cọc" : ""}}
                                    </span>
                                </td>
                                <td class="text-center text-no-wrap">{{ props.item.date_out | formatTimeServer }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.check_out_id }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.disbursement_id }}</td>
                                <td class="text-center">{{ props.item.amount | formatNumber}}</td>
                                <td class="text-center">{{ props.item.total_deposit | formatNumber}}</td>
                                <td class="text-center">{{ props.item.room_price | formatNumber}}</td>
                                <td class="text-center">{{ props.item.total_bill | formatNumber}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.debt_months && props.item.debt_months.length && props.item.debt_months.toString() || ''}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.debt_amount | formatNumber}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.fine_amount | formatNumber}}</td>
                                <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                                <td class="text-left text-no-wrap">{{ props.item.phone }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.month_live }} tháng</td>
                                <td class="text-left text-no-wrap">{{ props.item.note }}</td>
                                <!-- <td class="text-center">{{ props.item.expense_amount | formatNumber}}</td> -->
                            </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
	<v-dialog v-if="dialogDetail" v-model="dialogDetail" max-width="fit-content">
        <app-card>
            <div class="text-right">
                <v-btn @click="print_portal = true" color="secondary" flat icon>
                    <v-icon class="zmdi zmdi-print"></v-icon>
                </v-btn>
            </div>
			<return-deposit-bill-detail :bill="{...chosen_room_bill, ...chosen_return_deposit}"></return-deposit-bill-detail>
        </app-card>
    </v-dialog>
	<print-portal :open="print_portal" @close="print_portal = false">
        <return-deposit-bill-detail :bill="{...chosen_room_bill, ...chosen_return_deposit}"></return-deposit-bill-detail>
	</print-portal>
</div>
</template>

<script>
import api from "../../api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers.js'
import { list_building } from '../../constants/db-config'
import ReturnDepositBillDetail from '../../components/Bill/ReturnDepositBillDetail'
import PrintPortal from '../../components/Print/PrintPortal'

export default {
    name: 'bang-tinh-tien-tra-coc',
    components: {
        ReturnDepositBillDetail,
        PrintPortal
    },
    data() {
        return {
            search:'',
            search_type: 'roomId',
            headers: [
                { text: "Thao tác", align: "center", sortable: false, value: "room_id" },
                { text: "Số phòng", align: "center", sortable: false, value: "room_id" },
                { text: "Trạng thái", align: "center", sortable: false, value: "status" },
                { text: "Ngày trả", align: "center", value: "date_out" },
                { text: "Phiếu trả phòng", align: "center", value: "check_out_id" },
                { text: "Phiếu chi", align: "center", value: "disbursement_id" },
                { text: "Tiền trả cọc", align: "center", value: "amount" },
                { text: "Tiền cọc", align: "center", value: "total_deposit" },
                { text: "Tiền phòng trả trước", align: "center", value: "room_price" },
                { text: "Hóa đơn", align: "center", value: "total_bill" },
                { text: "Tháng nợ", align: "center", value: "debt_months" },
                { text: "Tổng tiền nợ", align: "center", value: "debt_amount" },
                { text: "Tổng tiền phạt", align: "center", value: "debt_amount" },
                { text: "Tên", align: "left", value: "name" },
                { text: "SDT", align: "left", value: "phone" },
                { text: "Thời gian ở", align: "center", value: "month_live" },
                { text: "Ghi chú", align: "left", value: "note" },
                // { text: "Đã trả", align: "center", value: "expense_amount" },
            ],
            detail_headers: [
                { text: "Tên", align: "center", sortable: false, value: "name" },
                { text: "SDT", align: "center", sortable: false, value: "name" },
                { text: "Xe máy", align: "center", sortable: false, value: "motorbike" },
                { text: "Xe đạp", align: "center", sortable: false, value: "bike" }
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: '',
            items: [],
            loading: {
                submit: false,
                getDetail: false,
                getList: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            chosen_contract: {},
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'),
            date_end: moment().endOf('month').format('YYYY-MM-DD'),
            dialogDetail: false,
            chosen_room_bill: {},
            chosen_return_deposit: {},
            print_portal: false
        };
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData: async function () {
            this.loading.getList = true
            this.items = []
            const params = {
                building: this.chosen_building,
                [this.search_type]: this.search,
                // dateStart: this.date_start,
                // dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            let data = await api.getListReturnDeposit(query)
            this.loading.getList = false
            if (data.status === 200 && data.data){
                this.items = data.data.map( receipt => {
                    receipt.status = !!receipt.disbursement_id
                    receipt.loading = false;
                    return receipt
                })
            }
        },
        getReturnDepositDetail: async function(room){
            this.chosen_room_bill = {}
            this.chosen_return_deposit = Object.assign({}, room)
            const params = {
                roomStateId: room.room_state_id,
                checkOutId: room.check_out_id
            }
            const query = buildParamQuery(params)
		    room.loading = true
            let data = await api.getRoomPayments(query)
		    room.loading = false

            if (data.status == 200 && data.data && data.data.length){
                this.chosen_room_bill = data.data[0]
                this.dialogDetail = true
            } else {
                swal.fire("Lỗi", 'Không tìm thấy thông tin phiếu trả cọc', "error")
            }
        }
    }
};
</script>
